import { api } from 'src/pages/APIs';
import AbstractApiService from 'src/services/abstractApiService';
import type { dynamicObj } from 'src/pages/assets';

export default class PurchaseOrderService extends AbstractApiService {
  public constructor({}) {
    super({});
  }

  public async getSuppliers(data: dynamicObj): Promise<any> {
    const querystring = this.encodeQueryData(data);
    return super.get(api.search_suppliers + '?' + querystring, {});
  }

  public async getPoCharges(data: dynamicObj): Promise<any> {
    const querystring = this.encodeQueryData(data);
    return super.get(
      api.get_purchase_order_distributed_charges + '?' + querystring,
      {},
    );
  }
}
